import ApiBaseService from "./ApiBaseService";

const getPosts = (page, rowsPerPage) => {
  return ApiBaseService.get(`/blog/posts`, {
    params: {
      page,
      rowsPerPage
    }
  });
};
const getPost = slug => {
  return ApiBaseService.get(`/blog/post/${slug}`);
};
export { getPost, getPosts };
